/* @ngInject */
export default class {
  constructor() {
    this.delivery_methods = [0, 6, 8, 9];
  }

  isCourse({ delivery_method }) {
    if (delivery_method && delivery_method.delivery_uid !== undefined)
      return this.delivery_methods.includes(delivery_method.delivery_uid);
    return this.delivery_methods.includes(delivery_method);
  }

  isExpired({ expiration_date }) {
    return { expired: expiration_date && new Date(expiration_date).getTime() < new Date().getTime() };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/CoursesClass.js